<template>
  <div>
    <!-- Modal -->
	    <Teleport to="body">    
    <div class="modal fade" id="addQuoteRequestModal" ref="modalEle" tabindex="-1" role="dialog"
         aria-labelledby="modelTitleId"
         aria-hidden="true">
      <div class="modal-dialog modal-full-width" role="document">
        <div class="modal-content">
          <div class="modal-header">
            <h5 class="modal-title">Ruch {{ selectedMovement?.document_number }}</h5>
            <button type="button" class="close ms-auto" data-bs-dismiss="modal" aria-label="Close">
              <span aria-hidden="true">&times;</span>
            </button>
          </div>

          <div class="modal-body pt-3">

            <div v-if="selectedArticles.length > 0" class="table-responsive"
                 style="border-bottom:1px solid #ddd; padding-bottom:20px">
              <h5>Lista wybranych artykułów</h5>
              <table class="table table-striped">
                <thead>
                <tr>
                  <th></th>
                  <th>#</th>
                  <th>Nr Katalogowy</th>
                  <th>Model</th>
                  <th>J.m.</th>
                  <th>Nazwa/Opis</th>
                      <th>Producent</th>
                  <th v-if="!isPWDocument()">Z Magazynu</th>
                  <th>Na Magazyn</th>
                  <th>Ilość</th>
                  <th>Opis ruchu</th>
				  <th v-if="isPWDocument()">Cena netto</th>
<th v-if="isPWDocument()">Lokalizacja</th>
                  <th>Os. Zlecająca</th>
                  <th v-if="!isPWDocument()">Os. Otrzymująca</th>
                  <th>Cel</th>
                </tr>
                </thead>
                <tbody>
                <tr v-for="article in selectedArticles" :key="article.id">
                  <td>
                    <button @click="removeFromSelectedArticles(article.id)" class="btn btn-outline-danger btn-xs">
                      Usuń
                    </button>
                  </td>
                  <td>{{ article.id }}</td>
                  <td>{{ article.catalog_number }}</td>
                  <td>{{ article.model }}</td>
                  <td>{{ article.article_unit?.name }}</td>
                  <td>{{ article.description }}</td>
						<td>{{ article.producer?.short_name }}</td>
                  <td v-if="!isPWDocument()">{{ warehouseName(selectedMovement.previous_warehouse_id) }}</td>
                  <td>{{ warehouseName(selectedMovement.warehouse_id) }}</td>
                  <td><input
					style="max-width: 100px"
					type="number"
					:step="isIntegerUnit(article.article_unit?.name) ? 1 : 0.01"
					min="0.01"
					v-model.number="article.quantity"
					@input="onIntegerInput(article)"
					@keydown="blockNonNumeric($event, article.article_unit?.name)"
					class="form-control form-control-sm"/>
					</td>
				  <td><input type="text" class="form-control form-control-sm" v-model="article.comment"></td>
				  <td v-if="isPWDocument()" style="min-width: 100px" >
					<div class="input-group">
					  <input
						type="number"
						class="form-control form-control-sm"
						min="0"
						step="0.01"
						v-model.number="article.price_netto_zl">
					  <span class="input-group-text">PLN</span>
					</div>
				  </td>
				  <td v-if="isPWDocument()"><input type="text" class="form-control form-control-sm" v-model="article.location"></td>
                  <td><input type="text" class="form-control form-control-sm" v-model="article.who_issuing"></td>
                  <td v-if="!isPWDocument()"><input type="text" class="form-control form-control-sm" v-model="article.who_receiving"></td>
                  <td><input type="text" class="form-control form-control-sm" v-model="article.purpose"></td>
                </tr>
                </tbody>
              </table>
              <button type="button" class="btn btn-primary" @click="submit" :disabled="isSubmitting">Dodaj
                wybrane pozycje
              </button>
            </div>

            <h5 class="pt-4 pb-2">Lista dostępnych artykułów</h5>
            <ejs-grid ref="addItemMovementGridRef" id="addItemMovementGrid" height="500px"
                      :dataSource="articlesDataManager"
					  :rowHeight="32"
                      :allowPaging="true"
                      :allowSorting="true"
                      :allowFiltering="true"
					  :allowReordering="true"
                      :pageSettings="pageSettings"
                      :editSettings="editSettings"
                      :filterSettings="filterOptions"
                      :toolbar="toolbar"
                      :selectionSettings="selectionOptions"
                      :actionBegin="actionBegin"
					  :enablePersistence="true"
					  :allowResizing="true"
                      :actionComplete="actionComplete"
					  :toolbarClick="clickToolbarHandler"
					  :dataBound="dataBoundHandler">
              <e-columns>
                <e-column headerText="Dodaj" width="80" :template="'addTemplate'" textAlign="Center"/>
                <e-column field="id" headerText="ID" width="100" :isPrimaryKey="true" :visible="false"/>
                <e-column field="photos" headerText="Zdjęcia" width="150" :template="'imageTemplate'"
                          :allowEditing="false" :allowFiltering="false" :allowSorting="false" type="string" :visible="false"/>
                <e-column field="catalog_number" headerText="Nr katalogowy" type="string"/>
                <e-column field="model" headerText="Model" type="string"/>
                <e-column field="article_unit.id" headerText="J.m." :visible="false"/>
                <e-column field="description" headerText="Nazwa/Opis" type="string"/>
                <e-column field="link" headerText="Link" :defaultValue="null" type="string"
                          :filter="filterDefault" :template="'linkTemplate'" :allowEditing="false"/>
                <e-column field="available_items.quantity" headerText="Stany magazynowe" width="150"
                          format="N2" :filter="filterNumeric" type="string" :allowEditing="false"/>
                <e-column field="location" headerText="Lokalizacja" width="150"
                          :filter="filterDefault" type="string" :allowEditing="false"/>
                <e-column field="price_netto_zl" headerText="Cena netto" width="150"
                          format="N2" :filter="filterNumeric" type="string" :allowEditing="false"/>
                   <e-column field="producer_name" headerText="Producent" editType="string"
                              :allowEditing="false" :dataSource="producers"
                              :filter="filterDefault"/>
              </e-columns>

              <template v-slot:addTemplate="{ data }">
<template v-if="!isArticleSelected(data.id)">
<button
  @click="addToNewItems(data)"
  :disabled="isAddBlocked(data)"
  :class="[
    'btn btn-xs',
    isAddBlocked(data) ? 'btn-outline-secondary' : 'btn-outline-primary'
  ]"
>
  Dodaj
</button>
</template>
                <template v-else>
                  <span class="text-success">Wybrano</span>
                </template>
              </template>


              <template v-slot:linkTemplate="{data}">
                <a class="link link-primary" target="_blank" rel="noopener noreferrer" :href=data.link>{{
                    data.link
                  }}</a>
              </template>

              <template v-slot:imageTemplate="{ data }">
                <div v-if="data.photos && data.photos.length > 0">
                  <img :src="`/${data.photos[0].photo_path}`" alt="Zdjęcie"
                       style="max-height: 100px; max-width: 150px"/>
                </div>
              </template>

            </ejs-grid>

          </div>
        </div>
      </div>
    </div>
 

<!-- MINI MODAL PW -->
<div class="modal fade" ref="qtyModalRef" tabindex="-1">
  <div class="modal-dialog modal-sm">
    <div class="modal-content">

      <div class="modal-header">
        <h5 class="modal-title">
          Dodanie artykułu PW
        </h5>

        <button 
          type="button" 
          class="btn-close" 
          data-bs-dismiss="modal">
        </button>
      </div>


      <div class="modal-body" v-if="pendingArticle">

        <label class="form-label">
          Ilość
        </label>

        <div class="input-group mb-2">

          <input
            type="number"
            class="form-control"
            v-model.number="pendingQuantity"
            :min="isIntegerUnit(pendingArticle.article_unit?.name) ? 1 : 0.01"
            :step="isIntegerUnit(pendingArticle.article_unit?.name) ? 1 : 0.01"
            @keydown="blockNonNumeric($event,pendingArticle.article_unit?.name)"
          >

          <span class="input-group-text">
            {{pendingArticle.article_unit?.name || '-'}}
          </span>

        </div>


        <label class="form-label">
          Cena netto
        </label>

        <div class="input-group mb-2">

          <input
            type="number"
            class="form-control"
            min="0"
            step="0.01"
            v-model.number="pendingArticle.price_netto_zl"
          >

          <span class="input-group-text">
            PLN
          </span>

        </div>


        <label class="form-label">
          Lokalizacja
        </label>

        <input
          type="text"
          class="form-control mb-2"
          v-model="pendingArticle.location"
        >


        <label class="form-label">
          Opis ruchu
        </label>

        <input
          type="text"
          class="form-control"
          v-model="pendingComments"
        >

      </div>


      <div class="modal-footer">

        <button 
          class="btn btn-secondary"
          data-bs-dismiss="modal">
          Anuluj
        </button>


        <button
          class="btn btn-primary"
          @click="confirmAdd">
          Dodaj
        </button>

      </div>

    </div>
  </div>
</div>
    </Teleport>  
	
  </div>
</template>

<script>
import {ref} from "vue";
import {Modal, Tooltip} from "bootstrap";
import {usePage} from "@inertiajs/vue3";
import {DatePickerComponent} from "@syncfusion/ej2-vue-calendars";
import {
  ColumnDirective,
  ColumnsDirective,
  Edit,
  GridComponent,
  Page,
  Reorder,
  Resize,
  Toolbar,
  VirtualScroll,
   Sort,
  Filter
} from '@syncfusion/ej2-vue-grids';

import {DataManager, Predicate, Query, WebMethodAdaptor} from "@syncfusion/ej2-data";
import {createElement} from "@syncfusion/ej2-base";
import {DropDownList} from "@syncfusion/ej2-dropdowns";
import {MultiSelect} from "@syncfusion/ej2-vue-dropdowns"

let dropInstanceFilterUnits, delivererElem = ref(null), multiSelectObj = ref(null);

export default {
  components: {
    'ejs-grid': GridComponent,
    'e-columns': ColumnsDirective,
    'e-column': ColumnDirective,
    'ejs-datepicker': DatePickerComponent
  },
  
provide: {
  grid: [Page, Edit, Toolbar, Reorder, Resize, VirtualScroll, Sort, Filter]
},
  props: {
    selectedMovement: Object,
	producers: Object,
    selectedItemToClone: {type: Array, default: () => []}
  },

  data() {
    return {
	copyproducers: this.producers,
	 hasSearch: false,
	    addQtyModal: null,
    pendingArticle: null,
    pendingQuantity: 1,
    pendingComments: '',
      articlesDataManager: [],
      selectedArticles: [],
      warehouses: [],
      isSubmitting: false,
      pageSettings: {pageSize: 50, pageCount: 5, pageSizes: [10, 20, 30, 50, 100]},
      filterOptions: {type: "Menu", operator: "contains"},
      filterDefault: {operator: 'contains', params: {minLength: 2}},
      filterNumeric: {operator: 'equal'},
      selectionOptions: {persistSelection: true},
      editSettings: {allowEditing: true, mode: 'Batch'},
    }
  },

mounted() {
  this.modalObj = new Modal(this.$refs.modalEle);

  this.addQtyModal = new Modal(this.$refs.qtyModalRef);

  this.getArticles();
  this.getWarehouses();
},
  computed: {
	  toolbar() {
    return this.getToolbar();
  }
  },

  watch: {
    selectedMovement() {
      this.selectedArticles = [];
    },
    selectedItemToClone: {
      immediate: true,
      deep: true,
      handler(val) {
        if (val && val.length) this.addManyFromClone(val);
      }
    }
  },

  methods: {
        dataBoundHandler() {
    const grid = this.$refs.addItemMovementGridRef.ej2Instances;

    const hasSearchNow = !!grid.searchSettings.key;

    if (this.hasSearch !== hasSearchNow) {
        this.hasSearch = hasSearchNow;
        this.toolbar = this.getToolbar();
    }
},


  confirmAdd() {

  if (!this.pendingArticle) {
    return;
  }


  const article = {
    ...this.pendingArticle,

    quantity: this.pendingQuantity,

    comment: this.pendingComments,

    price_netto_zl: this.pendingArticle.price_netto_zl ?? 0,

    location: this.pendingArticle.location ?? ''
  };


  if (!this.selectedArticles.find(a => a.id === article.id)) {

    this.selectedArticles.push(article);

  }


  this.pendingArticle = null;
  this.pendingComments = '';

  this.addQtyModal.hide();
},

  isPWDocument() {
  return this.selectedMovement?.document_number?.startsWith('PW');
},
isAddBlocked(data) {
  const qty = Number(data?.available_items?.quantity ?? 0);

  // blokuj tylko jeśli NIE PW i stan <= 0
  return !this.isPWDocument() && qty <= 0;
},
  isIntegerUnit(unitName) {
    return unitName && ['szt', 'kpl'].includes(unitName.toLowerCase());
  },

  // blokuje wpisywanie niecyfrowych znaków tylko dla całkowitych jednostek
  blockNonNumeric(event, unitName) {
    if (this.isIntegerUnit(unitName)) {
      if (!/[0-9]/.test(event.key) &&
          !['Backspace', 'ArrowLeft', 'ArrowRight', 'Delete', 'Tab'].includes(event.key)) {
        event.preventDefault();
      }
    }
  },

  // automatyczne zaokrąglenie dla całkowitych jednostek
  onIntegerInput(article) {
    if (this.isIntegerUnit(article.article_unit?.name)) {
      article.quantity = Math.floor(article.quantity);
    }
  },
  
    getArticles() {
      this.articlesDataManager = new DataManager({
        url: route('articles.get'),
        adaptor: new WebMethodAdaptor(),
        crossDomain: true,
        headers: [{'X-CSRF-TOKEN': usePage().props.csrf_token}]
      });
    },

    async getWarehouses() {
      const resp = await axios.get(route('get.article-warehouses'))
      this.warehouses = resp.data;
    },

    normalizeItemForMovement(input) {
      // Jeśli przyszło RPI (ma .article), bierzemy źródło pól z .article
      const rpi = input?.article ? input : null;
      const src = rpi ? rpi.article : input;

      // Stan dostępny – z różnych możliwych źródeł
      const qtyFromNotEmpty = Array.isArray(rpi?.not_empty_warehouses)
          ? rpi.not_empty_warehouses.reduce((s, w) => s + Number(w?.quantity || 0), 0)
          : 0;
      const qtyFromWarehouses =
          Number(rpi?.article_main_warehouse?.quantity || 0) +
          Number(rpi?.article_project_warehouse?.quantity || 0);
      const availableQty =
          qtyFromNotEmpty || qtyFromWarehouses || Number(src?.stock_quantity || 0) || 0;

      // Głęboka kopia src, żeby nie psuć oryginału
      const base = JSON.parse(JSON.stringify(src || {}));

      // Pola startowe z ruchu (jeśli są)
      const start = {
        comment: this.selectedMovement?.comment ?? '',
        who_issuing: this.selectedMovement?.who_issuing ?? '',
        who_receiving: this.selectedMovement?.who_receiving ?? '',
        purpose: this.selectedMovement?.purpose ?? '',
      };

return {
    id: base.id,

    catalog_number: base.catalog_number || '',
    model: base.model || '',
    description: base.description || '',
    article_unit: base.article_unit || (base.unit_id ? {
        id: base.unit_id,
        name: '',
        allow_decimal: 0
    } : null),

    photos: base.photos || [],
    files: base.files || [],

    available_items: {
        quantity: availableQty
    },

    // DODAJ TO
    price_netto_zl: base.price_netto_zl ?? 0,
    location: base.location ?? '',

    quantity: 1,

    ...start,
};
    },

    addManyFromClone(list) {
      if (!Array.isArray(list)) return;
      list.forEach((item) => {
        const normalized = this.normalizeItemForMovement(item);
        if (!normalized?.id) return;
        if (this.selectedArticles.some(a => a.id === normalized.id)) return; // bez duplikatów
        this.selectedArticles.push(normalized);
      });
    },

addToNewItems(rowData) {

  if (this.isPWDocument()) {

    this.pendingArticle = this.normalizeItemForMovement(rowData);
    this.pendingQuantity = 1;
    this.pendingComments = '';

    this.addQtyModal.show();

    return;
  }


  if (!this.selectedArticles.find(item => item.id === rowData.id)) {

    const article = this.normalizeItemForMovement(rowData);

    this.selectedArticles.push(article);
  }

},

    // addToNewItems(rowData) {
    //   if (!this.selectedArticles.find(item => item.id === rowData.id)) {
    //     // kopia, żeby nie modyfikować obiektu z grida
    //     const article = JSON.parse(JSON.stringify(rowData));
    //
    //     // Startowe wartości z selectedMovement
    //     article.quantity = article.quantity ?? 1;
    //     article.comment = this.selectedMovement?.comment ?? '';
    //     article.who_issuing = this.selectedMovement?.who_issuing ?? '';
    //     article.who_receiving = this.selectedMovement?.who_receiving ?? '';
    //     article.purpose = this.selectedMovement?.purpose ?? '';
    //
    //     this.selectedArticles.push(article);
    //   }
    // },

    isArticleSelected(id) {
      return this.selectedArticles.some(item => item.id === id);
    },

    removeFromSelectedArticles(articleId) {
      this.selectedArticles = this.selectedArticles.filter(item => item.id !== articleId);
    },

    warehouseName(id) {
      return this.warehouses.find(w => w.id === id)?.short_name || '';
    },

    async submit() {
      // 1) podstawowe walidacje
      if (!this.selectedArticles.length) {
        Toast?.fire?.({
          icon: 'warning',
          title: 'Brak pozycji',
          html: 'Najpierw dodaj co najmniej jeden artykuł.',
          toast: true,
          timer: 2500,
        });
        return;
      }

      // sprawdź ilości
      const errors = [];
      for (const a of this.selectedArticles) {
        const q = Number(a.quantity);
        if (!Number.isFinite(q) || q <= 0) {
          errors.push(`Artykuł #${a.id}: ilość musi być > 0`);
        }
      }

      if (errors.length) {
        Toast?.fire?.({
          icon: 'error',
          title: 'Błędne ilości',
          html: errors.join('<br>'),
        });
        return;
      }

      // 2) payload do backendu
      const payload = {
        document_number: this.selectedMovement?.document_number ?? null,
        previous_warehouse_id: this.selectedMovement?.previous_warehouse_id ?? null,
        warehouse_id: this.selectedMovement?.warehouse_id ?? null,
        items: this.selectedArticles.map(a => ({
		price_netto_zl: a.price_netto_zl ?? null,
			location: a.location ?? null,
          article_id: a.id,
          quantity: Number(a.quantity),
          comment: a.comment ?? '',
          who_issuing: a.who_issuing ?? '',
          who_receiving: a.who_receiving ?? '',
          purpose: a.purpose ?? '',
          additional_comment: this.selectedMovement?.additional_comment ?? '',
        })),
      };

      // 3) wysyłka
      this.isSubmitting = true;
      try {
        const resp = await axios.post(route('warehouse-movements.add-item.store', {movement: this.selectedMovement.id}), payload);

        Toast?.fire?.({
          icon: resp?.data?.icon || 'success',
          title: resp?.data?.title || 'Dodano pozycje',
          html: resp?.data?.message || 'Pozycje zostały dodane do ruchu.',
          timer: 2500,
        });

        // wyczyść listę wybranych, zamknij modal
        this.selectedArticles = [];
        this.$emit?.('items-added', resp?.data ?? null);
        this.hide();

      } catch (e) {
        const msg = e?.response?.data?.message || e?.message || 'Nie udało się dodać pozycji.';
        Toast?.fire?.({
          icon: 'error',
          title: 'Błąd',
          html: msg,
        });
        console.error(e);
      } finally {
        this.isSubmitting = false;
      }
    },


    getToolbar() {
	  const tools = [];
     tools.push(
        {text: "Resetuj filtry", prefixIcon: 'e-reset', id: 'reset_filters'},
        {text: "Lista artykułów", prefixIcon: 'e-table-of-content', id: 'articles_list'},
        {text: "Search", prefixIcon: 'e-search', id: "search", align: 'center'},
 		  );
		  
		if (this.hasSearch) {
			tools.push({
				text: "",
				prefixIcon: "e-close",
				id: "clear_search",
				align: 'center'
			});
		}  
		tools.push(		  
      {text: "Przywróć domyślny", prefixIcon: 'e-undo', id: "restore", align: 'right'},
        {text: "Odśwież", prefixIcon: 'e-refresh', id: "refresh", align: 'right'}
      );

      return tools;	
		
		
    },

    clickToolbarHandler: async function (args) {
      if (args.item.id === 'reset_filters') {
        this.$refs.addItemMovementGridRef.clearFiltering();
      }
      if (args.item.id === 'articles_list') {
        window.open(route('articles.index'), '_blank');
      }
      if (args.item.id === 'refresh') {
        this.$refs.addItemMovementGridRef.ej2Instances.refresh();
      }
	 if (args.item.id === 'restore') {
        let grid = this.$refs.addItemMovementGridRef;
        let gridName = 'grid' + grid.$el.id;
        grid.ej2Instances.enablePersistence = false;
        window.localStorage.setItem(gridName, "");
        grid.ej2Instances.destroy();
        location.reload();
      }
	  if (args.item.id === "clear_search") {
    const grid = this.$refs.addItemMovementGridRef.ej2Instances;

    grid.searchSettings.key = "";
    grid.query = new Query();    
    grid.search("");
    grid.refresh();

    this.hasSearch = false;
    this.values = "";
    this.toolbar = this.getToolbar();
}

    },

    actionBegin(args) {
      //
      // WYSZUKIWARKA- wyszukiwanie wielu wartości z separatorem (przecinek
      //
if (args.requestType === 'searching') {
  const grid = this.$refs.addItemMovementGridRef.ej2Instances;
  const keys = args.searchString.split(';');
  let predicate;

  if (grid.searchSettings.key !== '') {
    this.values = args.searchString;

    keys.forEach((key) => {
      const lowerKey = key.toLowerCase();

      grid.getColumns().forEach((col) => {
        let field = col.field;
        let value = key;

        if (field === 'producer_name') {
          const match = this.copyproducers.find(p =>
            p.name.toLowerCase().includes(lowerKey)
          );
          if (match) {
            value = match.name;
          } else {
            // nie znaleziono producenta - pomijamy tę kolumnę
            return;
          }
        }

        const predic = new Predicate(field, 'contains', value, true);

        if (!predicate) {
          predicate = predic;
        } else {
          predicate = predicate.or(predic);
        }
      });
    });

    grid.query = new Query().where(predicate);

  } else {
    grid.searchSettings.key = '';
  }

  this.refresh = true;
  this.valueAssign = true;
  this.removeQuery = true;
  grid.refresh();
}
    },

    actionComplete(args) {
      //
      // WYSZUKIWARKA - wyszukiwanie wielu wartości z separatorem (przecinek
      //
      if (args.requestType === "refresh" && this.valueAssign) {
        document.getElementById(
            this.$refs.addItemMovementGridRef.ej2Instances.element.id + "_searchbar"
        ).value = this.values;
        this.valueAssign = false;
      } else if (
          document.getElementById(
              this.$refs.addItemMovementGridRef.ej2Instances.element.id + "_searchbar"
          ).value === "" &&
          args.requestType === "refresh" &&
          this.removeQuery
      ) {
        this.$refs.addItemMovementGridRef.ej2Instances.query = new Query();
        this.removeQuery = false;
        this.$refs.addItemMovementGridRef.ej2Instances.refresh();
      }
	  	    if (args.requestType === "searching") {
    this.hasSearch = !!args.searchString;
    this.toolbar = this.getToolbar();
  }
    },

    hasError(field) {
      return this.errors && this.errors[field];
    },

    show() {
      if (this.modalObj) {
        this.modalObj.show();

        this.$nextTick(() => {
          if (this.isFilled) {
            this.generateDocument();
          }
        })
      }
    },

    hide() {
      if (this.modalObj) {
        this.modalObj.hide();
      }
    },
  }
}
</script>